import { AnalyticsClient, gtmSubscriber } from '@czechtv/analytics';

const analyticsSubscribers = [gtmSubscriber()];

const analytics = new AnalyticsClient(analyticsSubscribers);

export default analytics;
